import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Utilities
import { required } from '../../utilities/validation';

// FormState
class FindForm {
    alias = new FieldState('').disableAutoValidation().validators(required);

    state = new FormState({
        username: this.alias
    });

    gerValues() {
        return {
            username: this.alias.$
        };
    }
}

// Components
import Box from '../../components/Box';
import { Form, TextField } from '../../components/FormStateFields';
import Typography from '../../components/Typography';

// Component
interface IProps {
    form: FindForm;
    onSubmit: () => void;
}

class FindStep extends React.Component<IProps, {}> {

    handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.props.onSubmit();
    }

    render() {
        return (
            <Box pa={4}>
                <Typography type="headline">Join Network</Typography>
                <Typography type="subheading" color="textSecondary">
                    Please enter the network alias for the network you want to join.
                </Typography>
                <Form onSubmit={this.handleSubmit}>
                    <TextField
                        label="Network Alias"
                        type="text"
                        fieldState={this.props.form.alias}
                        margin="normal"
                        fullWidth={true}
                        autoFocus={true}
                    />
                    <button
                        style={{ opacity: 0, position: 'absolute' }}
                        type="submit"
                    />
                </Form>
            </Box>
        );
    }
}

export { FindForm };
export default observer(FindStep);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialogJoinFind.tsx